<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Kunden</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-4 col-lg-12">
                    <stats-card title="Alle Kunden"
                                type="gradient-primary"
                                :sub-title="total"
                                icon="fad fa-users"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-4 col-lg-12" v-for="(type, index) in addressTypes" :key="index">
                    <stats-card
                        :title="index"
                        type="gradient-orange"
                        :sub-title="type.toString()"
                        :icon="index === 'Person' ? 'fad fa-male': 'fad fa-building'"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <customers-table @changed="getCustomers" title="Mitarbeiter"></customers-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomersTable from '@/views/Tables/CustomersTable';
import StatsCard from '@/components/Cards/StatsCard';

export default {
    name: "Customers",
    components: {
        StatsCard,
        CustomersTable,
    },
    methods: {
        getCustomers(data) {
            this.customers = data.data;
            this.total = data.recordsTotal.toString();
        }
    },
    computed: {
        addressTypes() {
            let addressTypes = {}
            this.customers.map(item => {
                addressTypes[item.addressType] = (addressTypes[item.addressType] || 0) + 1;
            });
            return addressTypes;
        },
    },
    data() {
        return {
            value: 1,
            customers: [],
            total: '0'
        };
    },
}
</script>

<style scoped lang="scss">
.card-profile-stats {
    padding: 0.4em 0.8em 0 0;
    margin-bottom: 0.4em;
}

.card-profile-stats > div {
    text-align: center;
    padding: 0.1em 1.2em 0 1.2em;
    margin-bottom: 0;
}

@media (max-width: 1700px) {
    .card-profile-stats > div {
        text-align: center;
        padding: 0.1em 0.8em 0 0;
        margin-bottom: 0;
    }
}

.sectionIcon {
    top: 1.5em;
    position: absolute;
    right: 1em;
}
</style>
